/**
 * Placeholder wordmark. Replace with the logo artwork (Open-Tech mark + "OPTego") once it exists,
 * e.g. <img src="/brand/logo.svg" alt="" height={36} /> — Header and Footer only render this component.
 */
export default function Logo({ inverse = false }: { inverse?: boolean }) {
  return (
    <span className={inverse ? 'logo logo--inverse' : 'logo'} aria-hidden="true">
      Opt<span className="logo__accent">ego</span>
    </span>
  );
}
